import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractDateToXml'
})
export class ExtractDateToXmlPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let index = value.indexOf("_")+12;
    return value.slice(index,index+10);
  }

}
